import { mooberApiV1 as apiV1, mooberApiV2 as apiV2 } from '@/api/mooberApi';

const all = () => apiV1.get('company');
const byId = ({ id }) => apiV1.get(`company/${id}`);
const update = ({ company }) => apiV1.post(`company/${company.id}`, company);
const create = ({ company }) => apiV1.post('company', company);

const sendInvite = ({ companyId, body }) => apiV1.post(`invitation/company/${companyId}/employee`, body);
const addTruckingInfo = ({ companyId, body }) => apiV1.post(`company/${companyId}/truckingInfo`, body);
const removeTruckingInfo = ({ companyId }) => apiV1.delete(`company/${companyId}/truckingInfo`);
const removeProducerInfo = ({ companyId }) => apiV1.delete(`company/${companyId}/producerInfo`);
const addW9Files = ({ companyId, body }) => apiV1.post(`company/${companyId}/truckingInfo/w9`, body);
const addInsurancePolicy = ({ companyId, body }) => apiV1.post(`company/${companyId}/truckingInfo/insurancePolicy`, body);
const addProducerInfo = ({ companyId, body }) => apiV1.post(`company/${companyId}/producerInfo`, body);
const deleteEmployee = ({ companyId, userId }) => apiV1.delete(`company/${companyId}/employee/${userId}`);
const editLoadingInfo = ({ companyId, body }) => apiV1.post(`company/${companyId}/loadingInfo`, body);
const saveLoadRequirements = ({ companyId, body }) => apiV1.post(`company/${companyId}/saveLegacyLoadRequirements`, body);
const getBookedLoads = ({ companyId }) => apiV1.get(`simpleDashboard/${companyId}/bookedLoads`);
const getListings = ({ companyId }) => apiV1.get(`simpleDashboard/${companyId}/listings`);
const updateEmployeePermissions = ({ companyId, userId, body }) => apiV1.post(`company/${companyId}/employee/${userId}/permission`, body);
const submitTemporarySignup = ({ signupInfo }) => apiV1.post('onboard/temporaryCompanyAccountSignup', signupInfo);
const verifyAccount = ({ id, status }) => apiV1.post(`company/${id}/verify`, status);
const placeHoldOnAccount = ({ id, status }) => apiV1.post(`company/${id}/place-hold`, status);
const removeHoldFromAccount = ({ id, status }) => apiV1.post(`company/${id}/remove-hold`, status);
const timeline = ({ companyId }) => apiV1.get(`timeline/company/${companyId}`);
const addHistoryComment = ({ companyId, message }) => apiV1.post(`timeline/company/${companyId}`, message);
const updateCompanyCode = ({ companyId, codeUpdate }) => apiV1.post(`company/${companyId}/code`, codeUpdate);
const getInvitations = ({ companyId }) => apiV1.get(`invitation/company/${companyId}`);
const notifyInsuranceCarrier = ({ companyId, body }) => apiV1.post(`company/${companyId}/notifyInsuranceCarrier`, body);
const confirmInsuranceCertificate = ({ companyId, reason }) => apiV1.post(`company/${companyId}/confirmCarrierInsuranceCertificate`, { reason });

const getBids = companyId => apiV1.get(`companyDashboard/${companyId}/bids`);

// API V2 usage
const catalog = () => apiV2.get('company');
const mine = () => apiV2.get('company/mine');

const getPlannedLoads = ({ companyId }) => apiV2.get(`companyDashboard/${companyId}/plannedLoads`);
const getLoadHistory = ({ companyId, year, month }) => apiV2.get(`companyDashboard/${companyId}/loadHistory/${year}/${month}`);
const getRepeatLoadTemplates = ({ companyId }) => apiV2.get(`companyDashboard/${companyId}/repeatLoadTemplates`);
const saveRepeatLoad = ({ loadId, body }) => apiV2.post(`repeatLoad/${loadId}`, body);
const getRepeatLoad = loadId => apiV2.get(`repeatLoad/${loadId}`);
const postLoadV2 = ({ companyId, body }) => apiV2.post(`company/${companyId}/load`, body);
const deleteLoadTemplate = loadId => apiV2.delete(`load/${loadId}/repeat`);
const scheduleLoad = ({ loadId, body }) => apiV2.post(`repeatLoad/${loadId}/schedule`, body);
const addDispatchContact =(companyId, body) => apiV2.post(`company/${companyId}/dispatchContact`, body);
const deleteDispatchContact = (companyId, contactId) => apiV2.delete(`company/${companyId}/dispatchContact/${contactId}`);

export default {
  all,
  byId,
  update,
  create,
  sendInvite,
  addTruckingInfo,
  removeProducerInfo,
  removeTruckingInfo,
  addW9Files,
  addInsurancePolicy,
  addProducerInfo,
  deleteEmployee,
  editLoadingInfo,
  getBookedLoads,
  getListings,
  updateEmployeePermissions,
  submitTemporarySignup,
  placeHoldOnAccount,
  removeHoldFromAccount,
  verifyAccount,
  timeline,
  getInvitations,
  addHistoryComment,
  updateCompanyCode,
  notifyInsuranceCarrier,
  confirmInsuranceCertificate,
  getBids,
  saveLoadRequirements,

  catalog,
  mine,
  postLoadV2,
  getPlannedLoads,
  getLoadHistory,
  getRepeatLoadTemplates,
  deleteLoadTemplate,
  saveRepeatLoad,
  getRepeatLoad,
  scheduleLoad,
  addDispatchContact,
  deleteDispatchContact
};



// WEBPACK FOOTER //
// ./src/api/company.js